import partition from 'lodash/partition';

import type { GlobalShortcutsItem } from '@atlassian/global-shortcuts';

import type { HasMenuId, NavItemConfigInternal } from '../../types';

export const partitionByReorderable = <
	T extends (HasMenuId & NavItemConfigInternal) | (HasMenuId & GlobalShortcutsItem),
>(
	items: T[],
): [T[], T[]] => partition(items, (item) => item.isReorderable);
